import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
import { showLoader, hideLoader } from '../../../store/common/slice';
import { oneLineSelectStyles } from '../../../common/shared/select.styled';
import { constants } from '../../../common/constants/constants';
import Datepicker from '../../../common/DatepickerPortal';
import Button from '../../../common/Button';
import Input from '../../../common/simple/input';
import transferCoins from '../../../images/newDesign/transfer_coins.svg';
import bllinkLogo from '../../../images/newDesign/bllink_logo.svg';
import check from '../../../images/newDesign/check.svg';
import wire from '../../../images/newDesign/wire_building.svg';
import cheque from '../../../images/newDesign/cheque_payment.svg';
import cash from '../../../images/newDesign/cash.svg';

const AddPaymentMethodOneTime = ({ 
        amount, 
        currency, 
        vendorName, 
        choosePaymentMethod, 
        setChoosePaymentMethod, 
        paymentMethod, 
        onMethodChange, 
        buildingID, 
        vendor, 
        vendorID,
        setShowConfirmation,
        date,
        setConfirmationDate,
        setShowAddExpense,
        setShowAddPaymentMethod,
        setAddPaymentMethodPayload,
        showFromReport
    }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const ltr = useSelector(state => state.common.ltrEnabled);

    document.querySelector('.fade').scrollTo(0,0);

    const [bllinkOrCashDate, setBllinkOrCashDate] = useState(new Date(date));
    const [chequeOrWireData, setChequeOrWireData] = useState({
        date: new Date(date),
        chequeOrWireNum: '',
        bank: '',
        branch: '',
        accountNum: ''
    });
    const [btnDisabled, setBtnDisabled] = useState(true);

    const currencySign = t(`currency.${currency}`);

    const codes = currency.toUpper === 'MXN' ? constants.bankCodesInMexico : constants.bankCodesInIsrael;
    const country = currency.toUpper === 'MXN' ? 'mexico' : 'israel';
    const bankOptions = codes.map(value => ({ value, label: `${value} - ${t(`common.banks.${country}.${value}`)}` }));

    const bllinkPay = paymentMethod === constants.managerPaymentsOptions.bankCharge;
    const cashPay = paymentMethod === constants.managerPaymentsOptions.cash;
    const wirePay = paymentMethod === constants.managerPaymentsOptions.wire;
    const chequePay = paymentMethod === constants.managerPaymentsOptions.cheque;

    const onBllinkOrCashDatePickerChange = date => {
        setBllinkOrCashDate(date);
        setConfirmationDate(date);
    };

    const onChequeOrWireDataChange = (e, name, dateOrBank, date) => {
        if (date) setConfirmationDate(e)

        if (!dateOrBank) {
            setChequeOrWireData({
                ...chequeOrWireData,
                [name]: e.target.value
            })
        } else {
            setChequeOrWireData({
                ...chequeOrWireData,
                [name]: e
            })
        }
    };

    useEffect(() => {
        if (bllinkPay || cashPay) {
            if (bllinkOrCashDate) setBtnDisabled(false)
            else setBtnDisabled(true)
        } else {
            const { date } = chequeOrWireData;
            if (date) setBtnDisabled(false)
            else setBtnDisabled(true)
        }
    }, [bllinkOrCashDate, chequeOrWireData]);

    const onContinueClick = () => setChoosePaymentMethod(false);

    const onApproveClick = async () => {
        dispatch(showLoader());

        let payload;

        if (bllinkPay || cashPay) {
            payload = {
                buildingID,
                paymentDate: {
                    month: bllinkOrCashDate.getMonth()+1,
                    year: bllinkOrCashDate.getFullYear(),
                    day: bllinkOrCashDate.getDate()
                },
                paymentMethod: paymentMethod,
                vendorID: vendorID || vendor.value
            };
        } else {
            payload = {
                buildingID,
                paymentDate: {
                    month: chequeOrWireData?.date.getMonth()+1,
                    year: chequeOrWireData?.date.getFullYear(),
                    day: chequeOrWireData?.date.getDate()
                },
                extraDetails: {
                    chequeID: chequeOrWireData?.chequeOrWireNum,
                    bankCode: chequeOrWireData?.bank,
                    branchNumber: chequeOrWireData?.branch,
                    accountNumber: chequeOrWireData?.accountNum
                },
                paymentMethod: paymentMethod,
                vendorID: vendorID || vendor.value
            };
        }

        setAddPaymentMethodPayload(payload);
        setShowConfirmation(true);

        dispatch(hideLoader());
    };

    const onStepBackClick = () => {
        setShowAddPaymentMethod(false);
        setShowAddExpense(true);
        setChoosePaymentMethod(true);
    };

    return (
        <div className='set-one-time-payment'>
            <div className='progress-line'>
                <div className='step'>
                    <div className='progress-step current' onClick={!showFromReport ? onStepBackClick : () => {}}><img src={check} /></div>
                    <div className='current-text'>{t('expenses.set_expenses.first_step')}</div>
                </div>

                <div className='divider-line first'></div>
                <div className='divider-line-done-first'></div>

                <div className='step'>
                    <div className='progress-step'>2</div>
                    <div>{t('expenses.set_expenses.second_step')}</div>
                </div>

                <div className='divider-line second'></div>

                <div className='step'>
                    <div className='progress-step'>3</div>
                    <div>{t('expenses.set_expenses.third_step')}</div>
                </div>
            </div>
            {choosePaymentMethod && (
                <>
                    <div className='set-payment-info margin'>{t('expenses.set_expenses.set_one_time_payment', 
                        {
                            returnObjects: true,
                            amount: (<span class='add-payment-highlithed'>{amount}</span>), 
                            currency: (<span class='add-payment-highlithed'>{currencySign}</span>), 
                            vendorName: (<span class='add-payment-highlithed'>{vendorName}</span>)
                        })}
                    </div>
                    <div 
                        className={`payment-method bllink-method ${bllinkPay ? 'selected' : ''}`}
                        onClick={() => onMethodChange(constants.managerPaymentsOptions.bankCharge)}
                    >
                        <img src={bllinkLogo} />
                        <div>
                            <div>{t('expenses.set_expenses.pay_with_bllink')}</div>
                            <div className='notice'>{t('expenses.set_expenses.free')}</div>
                        </div>
                    </div>

                    <div className='one-time-divider'></div>

                    <div 
                        className={`payment-method ${wirePay ? 'selected' : ''}`}
                        onClick={() => onMethodChange(constants.managerPaymentsOptions.wire)}
                    >
                        <img src={wire} />
                        <div>
                            <div>{t('expenses.set_expenses.record_wire_payment')}</div>
                        </div>
                    </div>

                    <div 
                        className={`payment-method ${chequePay ? 'selected' : ''}`}
                        onClick={() => onMethodChange(constants.managerPaymentsOptions.cheque)}
                    >
                        <img src={cheque} />
                        <div>
                            <div>{t('expenses.set_expenses.record_cheque_payment')}</div>
                        </div>
                    </div>

                    <div 
                        className={`payment-method ${cashPay ? 'selected' : ''}`}
                        onClick={() => onMethodChange(constants.managerPaymentsOptions.cash)}
                    >
                        <img src={cash} />
                        <div>
                            <div>{t('expenses.set_expenses.record_cash_payment')}</div>
                        </div>
                    </div>

                    <Button
                        type='button'
                        onClick={onContinueClick}
                        rounded={false}
                    >                 
                        {t('expenses.set_expenses.continue')}
                    </Button>                 
                </>
            )}

            {!choosePaymentMethod && (
                <>
                    <div className='set-payment-info'>{t('expenses.set_expenses.set_one_time_payment', 
                        {
                            amount: (<span class='add-payment-highlithed'>{amount}</span>), 
                            currency: (<span class='add-payment-highlithed'>{currencySign}</span>), 
                            vendorName: (<span class='add-payment-highlithed'>{vendorName}</span>)
                        })}
                    </div>

                    {(bllinkPay || cashPay) && (
                        <>
                            <div className='payment-method-info'>
                                <img src={bllinkPay ? bllinkLogo : cash} />
                                <div>
                                    <div>{bllinkPay ? t('expenses.set_expenses.pay_with_bllink') : t('expenses.set_expenses.cash_payment')}</div>
                                    {bllinkPay && <div className='notice'>{t('expenses.set_expenses.free')}</div>}                                   
                                </div>
                            </div>
        
                            <div className='datepicker-wrapper select-payment'>
                                <label>{t('offline_payments.payment_date')}</label>
                                <Datepicker 
                                    date={bllinkOrCashDate}
                                    onChange={onBllinkOrCashDatePickerChange}          
                                    className='one-line-design'
                                    placeholder={t('expenses.set_expenses.select_date')}
                                    ltr={ltr}
                                    withPortal={false}
                                    showArrow={false}
                                    container
                                />
                            </div>
        
                            <img src={transferCoins} className='transfer-coins-img' />
                        </>
                    )}

                    {(chequePay || wirePay) && (
                        <>
                            <div className='payment-method-info'>
                                <img src={chequePay ? cheque : wire} />
                                <div>{chequePay ? t('expenses.set_expenses.cheque_payment') : t('expenses.set_expenses.wire_payment')}</div>
                            </div>
        
                            <div className='datepicker-wrapper select-payment'>
                                <label>{t('expenses.deposit_date')}</label>
                                <Datepicker 
                                    date={chequeOrWireData.date}
                                    onChange={e => onChequeOrWireDataChange(e, 'date', true, true)}          
                                    className='one-line-design'
                                    placeholder={t('expenses.set_expenses.select_date')}
                                    ltr={ltr}
                                    withPortal={false}
                                    showArrow={false}
                                    container
                                />
                            </div>
        
                            <Input 
                                label={chequePay ? t('expenses.cheque_num') : t('expenses.set_expenses.wire_confirmation_num')}  
                                value={chequeOrWireData.chequeOrWireNum} 
                                onChange={e => onChequeOrWireDataChange(e, 'chequeOrWireNum')} 
                            />

                            <div className='dropdown-wrapper margin'>
                                <label>{t('expenses.bank')}</label>
                                <Select
                                    styles={oneLineSelectStyles}
                                    isRtl={!ltr}
                                    options={bankOptions}
                                    value={chequeOrWireData.bank}
                                    onChange={e => onChequeOrWireDataChange(e, 'bank', true)}
                                />
                            </div>

                            <Input 
                                label={t('expenses.branch')}  
                                value={chequeOrWireData.branch} 
                                onChange={e => onChequeOrWireDataChange(e, 'branch')} 
                            />

                            <Input 
                                label={t('expenses.account')}  
                                value={chequeOrWireData.accountNum} 
                                onChange={e => onChequeOrWireDataChange(e, 'accountNum')}  
                            />
                        </>
                    )}

                    <Button
                        type='button'
                        onClick={onApproveClick}
                        rounded={false}
                        disabled={btnDisabled}
                    >                 
                        {t('expenses.approve')}
                    </Button>
                </>
            )}
        </div>
    )
}

export default AddPaymentMethodOneTime;